import React from 'react'

import { AiTextImprover } from 'apps/aiTextImprover/AiTextImprover'
import { useEditorAiTextImprover } from 'components/MCTextEditor/toolbar/popovers/EditorAiTextImprover/useEditorAiTextImprover'
import { IToolHandler } from 'components/MCTextEditor/types'

interface EditorAiTextImproverProps {
  onSelect?: IToolHandler
}

export const EditorAiTextImproverPopover = ({ onSelect }: EditorAiTextImproverProps) => {
  const { text, replaceText, flowNs, maxLength } = useEditorAiTextImprover({ onSelect })

  return (
    <AiTextImprover
      newTextMaxLength={maxLength}
      initialText={text}
      onSubmit={replaceText}
      flowNs={flowNs}
    />
  )
}
